export default "__VITE_ASSET__87562a6b__"